export default __webpack_public_path__ + "static/media/learnmore.5ecf90c5.svg";